/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root',
})
export class NetworkDetectService {
  private networkStatus = true;

  constructor() {
    Network.addListener('networkStatusChange', (status) => {
      this.setNetworkStatus(status.connected);
    });
  }

  public getNetworkStatus() {
    return this.networkStatus;
  }
  public setNetworkStatus(value) {
    this.networkStatus = value;
  }
}
